<template>
	<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 480" xml:space="preserve">
		<path d="M424,224h-56V56c0-2.334-1.02-4.552-2.792-6.072l-56-48C307.758,0.684,305.911,0,304,0H120c-4.418,0-8,3.582-8,8v216H56
			c-30.913,0.035-55.965,25.087-56,56v112c0,4.418,3.582,8,8,8h70.984c4.418,0,8-3.582,8-8s-3.582-8-8-8H16V280
			c0.026-22.08,17.92-39.974,40-40h368c22.08,0.026,39.974,17.92,40,40v104h-56.104c-4.418,0-8,3.582-8,8s3.582,8,8,8H472
			c4.418,0,8-3.582,8-8V280C479.965,249.087,454.913,224.035,424,224z M352,224H128V16h173.04L352,59.68V224z"/>
		<path d="M407.76,470.064l-32-128c-0.889-3.563-4.088-6.063-7.76-6.064H120c-3.672,0.001-6.871,2.501-7.76,6.064l-32,128
			c-0.158,0.633-0.238,1.282-0.238,1.934c-0.001,4.418,3.58,8.001,7.998,8.002h312c0.652,0,1.301-0.08,1.934-0.238
			C406.221,478.693,408.829,474.351,407.76,470.064z M98.248,464l28-112h235.504l28,112H98.248z"/>
		<path d="M336,408H144c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S340.418,408,336,408z"/>
		<path d="M336,432H144c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S340.418,432,336,432z"/>
		<path d="M384,304H96c-4.418,0-8,3.582-8,8s3.582,8,8,8h288c4.418,0,8-3.582,8-8S388.418,304,384,304z"/>
	</svg>
</template>

<script>
	export default {
		name: "IconPrint"
	}
</script>
